<template>
  <!--  show PWA-->
  <!--  <PWABlock v-if="true" />-->
  <SomethingGoingWrong
    v-if="store.state.app.isCrashed"
  />
  <PWABlock
    v-else-if="!state.isStandalone && !route.meta.isPublic"
  />
  <NewVersionAvailable
    v-else-if="store.state.app.isNewVersionAvailable || store.state.app.isVersionRefreshing"
  />
  <NoConnection
    v-else-if="!store.state.app.isOnline"
  />
  <router-view
    v-else-if="route.meta.isDesktop && !store.state.user.isRestoring"
  />
  <router-view
    :key="$route.fullPath"
    v-else-if="!store.state.user.isRestoring"
  />
  <transition
    v-show="store.state.user.isRestoring"
    name="fade"
  >
    <SplashScreen
      v-if="state.splashScreenNeeded"
    />
  </transition>

  <component
    :is="messageComponents[store.state.app.messageComponent]"
    v-if="store.state.app.messageComponent"
    :data="store.state.app.messageComponentData"
  />
</template>

<script setup>
import {defineAsyncComponent, onBeforeMount, onUnmounted, reactive, watch} from 'vue'
import {useRoute} from 'vue-router'
import store from './store/store'
import SplashScreen from '@/views/SplashScreen.vue'
import {imagesLinkCache} from '@/utils/imagesLinkCache'
import NoConnection from '@/views/system/NoConnection.vue'
import SomethingGoingWrong from '@/views/system/SomethingGoingWrong.vue'
import {pwaUtils} from "@/utils/pwaUtils.js"
import NewVersionAvailable from '@/views/system/NewVersionAvailable.vue'
import {yandexMetrika} from "@/external/yandexWebisor.js"
import {messageComponents} from '@/components/messageComponents/messageComponents.js'
import {appType, appTypes} from '@/appType/appType.js'

const PWABlock = defineAsyncComponent(() => import('@/views/system/PWABlock.vue'))

const route = useRoute()

const state = reactive({
  splashScreenNeeded: true,
  isStandalone: pwaUtils.isStandalone(),
  checkInterval: null,
  scrollTop: document.documentElement.scrollTop,
})

watch(() => store.state.user.isRestoring, isRestoring => {
  if (!isRestoring) {
    setTimeout(() => {
      state.splashScreenNeeded = false
    }, 500)
  } else {
    state.splashScreenNeeded = true
  }
})

onBeforeMount(async () => {
  imagesLinkCache.restore()
  document.body.classList.add('dark-theme')

  if (state.isStandalone) {
    yandexMetrika('reachGoal', 'appInstalled')
  }

  if (pwaUtils.isAppleMobile() && appType === appTypes.TELEGRAM) {
    state.checkInterval = setInterval(() => {
      if (document.documentElement.scrollTop) {
        document.documentElement.scrollTo(0, 0)
      }
    }, 0)
    document.addEventListener('scroll', (e) => {
      document.documentElement.scrollTo(0, 0)
    })
  }
})

onUnmounted(() => {
  clearInterval(state.checkInterval)
})

</script>

<style lang="scss">
@import "@/assets/variables";

:root {
  --document-height: calc(100svh - 0px);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity .3s ease, background-color .3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  background-color: transparent;
}
</style>
